export default {
  ConfirmEmailFormFields__ARIA: "email address",
  ConfirmEmailFormFields__ARIA_CONFIRMATION: "confirm email",
  ConfirmEmailFormFields__ERROR_EMAIL_MISMATCH: "Email address does not match",
  ConfirmEmailFormFields__LABEL: "Email address",
  ConfirmEmailFormFields__LABEL_CONFIRMATION: "Confirm email address",
};
